(() => {
  const norm = (s) =>
    (s || "")
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, " ");

  const getSelectedColor = (root) => {
    const checked = root.querySelector('input[type="radio"]:checked');
    if (checked && checked.value) return norm(checked.value);

    const sel = root.querySelector('select[name^="options["]');
    if (sel && sel.value) return norm(sel.value);

    return "";
  };

  const getKey = (el) => {
    const img = el.querySelector("img");
    if (!img) return "";
    return norm(img.getAttribute("alt") || img.getAttribute("data-alt") || img.src);
  };

  const pickSelectors = (root) => {
    const media = root.querySelectorAll(
      [
        ".product__media-item",
        ".product-media__item",
        ".media-gallery__item",
        "[data-media-id]",
        ".product-single__media",
      ].join(",")
    );

    const thumbs = root.querySelectorAll(
      [
        ".thumbnail-list__item",
        ".product__media-thumbnail",
        ".media-thumbnail",
        "[data-thumbnail-id]",
        ".product__media-list .thumbnail",
      ].join(",")
    );

    return { media, thumbs };
  };

  const filter = (root) => {
    const color = getSelectedColor(root);
    if (!color) return;

    const { media, thumbs } = pickSelectors(root);
    if (!media.length && !thumbs.length) return;

    const showIfMatch = (el) => {
      const key = getKey(el);
      const show = key.includes(color);
      el.style.display = show ? "" : "none";
      return show;
    };

    let firstThumbToClick = null;

    thumbs.forEach((t) => {
      const visible = showIfMatch(t);
      if (!firstThumbToClick && visible) firstThumbToClick = t;
    });

    media.forEach((m) => showIfMatch(m));

    if (firstThumbToClick) {
      const clickable = firstThumbToClick.querySelector("button, a");
      if (clickable) clickable.click();
    }
  };

  const init = () => {
    const roots = document.querySelectorAll(
      ["main", "[data-product-section]", ".product", ".product__info-container"].join(",")
    );

    roots.forEach((root) => {
      const form = root.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      filter(root);
      form.addEventListener("change", () => filter(root));
    });
  };

  document.addEventListener("DOMContentLoaded", init);
})();
